<template>
  <div class="book-summary-details">
    <div class="row">
      <div class="col-lg-3">
        <div class="image">
          <img :src="book?.imageUrl" />
        </div>
        <div class="info">
          <p>{{ book?.title }}</p>
          <p>{{ book?.author }}</p>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="wrapper">
          <div class="details">
            <p>{{ book?.description }}</p>
          </div>
          <div class="actions">
            <button @click="onShareBook">
              <img src="../../../../../public/assets/images/website/zadi/share.png" />
              مشاركة الملخص
            </button>
          </div>
        </div>
      </div>
    </div>
    <share-popup type="BOOK" :entity="book" />
  </div>
</template>

<script>
import SharePopup from "../shared/SharePopup.vue";

export default {
  components: { SharePopup },
  props: {
    book: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    onShareBook() {
      this.$nextTick(() => {
        $(`#share-popup-book`).modal('show');
      });
    }
  },
};
</script>

<style scoped>
.book-summary-details {
  width: 100%;
}

.wrapper {
  border-radius: 25px;
  border: 2px solid #dbdbdb;
  background: #F9F9F9;
  padding: 20px;
}

.image img {
  border-radius: 16px;
  border: 2px solid #86ccd4;
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.info {
  font-weight: 500;
  font-size: 17px;
  display: flex;
  align-items: center;
  flex-direction: column;
  row-gap: 5px;
  margin-top: 10px;
  text-align: center;
}

.info p:first-child {
  font-weight: 600;
  color: #86ccd4;
  font-size: 22px;
  text-align: center;
}

.info p:last-child {
  font-weight: 500;
  font-size: 18px;
  text-align: center;
}

.details {
  margin-bottom: 28px;
  min-height: 171px;
}

.details p {
  font-weight: 500;
  font-size: 17px;
  text-align: justify;
}

.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.actions button {
  background: #f4acbf;
  border-radius: 10px;
  color: #ffffff;
  padding: 6px;
  font-size: 16px;
  width: 210px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
}

.actions button img {
  width: 25px;
}

.actions button:hover {
  background: #f58da9;
}

@media (max-width: 992px) {
  .image {
    margin-top: 0px;
  }

  .image img {
    object-fit: cover;
  }

  .info {
    margin-bottom: 30px !important;
    text-align: justify !important;
  }

  .details p {
    overflow-y: hidden !important;
    min-height: 285px !important;
    padding-inline-end: 0px !important;
  }

  .actions {
    justify-content: center;
  }
}
</style>